module.exports = __webpack_public_path__ + "static/aon-categories-ecfe14731a454de01719a116550fe31a.png";